import { SelectFields } from '@repo/toolkit/types'

import { PaymentRecord } from '../../models/payment-record/payment-record'
import { FieldsSelector } from '../../utils'

export const enrollmentPaymentRecordTableFields = [
  'id',
  'type',
  'amount',
  'means',
  'dateDue',
  'dateEffective',
  'status'
] as const satisfies FieldsSelector<PaymentRecord>

export type EnrollmentPaymentRecordTableType = SelectFields<
  PaymentRecord,
  typeof enrollmentPaymentRecordTableFields
>

export const paymentRecordClientPaymentFields = [
  'id',
  'status',
  'type',
  'amount',
  'dateDue',
  'dateEffective',
  'cardNumber',
  'means'
] as const satisfies FieldsSelector<PaymentRecord>

export type PaymentRecordClientPaymentType = SelectFields<
  PaymentRecord,
  typeof paymentRecordClientPaymentFields
>

export const paymentRecordEnrollmentProfileMonitoringFields = [
  'id',
  'status',
  'type',
  'amount',
  'refundReason',
  'dateDue',
  'dateEffective',
  'cardNumber',
  'means'
] as const satisfies FieldsSelector<PaymentRecord>

export type PaymentRecordEnrollmentProfileMonitoringType = SelectFields<
  PaymentRecord,
  typeof paymentRecordEnrollmentProfileMonitoringFields
>
